import { Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { union_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { printf, toText } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { empty, append, singleton, delay, toList } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import * as react from "react";
import { HTMLAttr } from "../../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { defaultArg, value } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { Page } from "../Tickets/Types.fs.js";
import { navigationArrow, bfsTile } from "../Shared/Tile.fs.js";
import { nothing, errorMsg, spinner } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";

export class HelpBoxSize extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Narrow", "Wide", "FullWidth"];
    }
}

export function HelpBoxSize_$reflection() {
    return union_type("Help.View.HelpBoxSize", [], HelpBoxSize, () => [[], [], []]);
}

export class IconType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Light", "Dark", "MediumDark", "Orange"];
    }
}

export function IconType_$reflection() {
    return union_type("Help.View.IconType", [], IconType, () => [[], [], [], []]);
}

function iconUrl(image, icontype) {
    const postfix = (icontype.tag === 1) ? "_3" : ((icontype.tag === 0) ? "_2" : ((icontype.tag === 3) ? "_1" : "_4"));
    return toText(printf("help/%s%s.png"))(image)(postfix);
}

function narrowhtmlBox(ueberschrift, image, icontype, html, additionalLink, onClick) {
    let children_16, children_14, children_8, children_6, children_4, children_10, props_10;
    const children_18 = [(children_16 = [(children_14 = [(children_8 = [(children_6 = [(children_4 = toList(delay(() => singleton((onClick == null) ? react.createElement("span", {
        className: "help-head",
    }, ueberschrift) : react.createElement("a", {
        className: "help-head",
    }, ueberschrift)))), react.createElement("b", {}, ...children_4))], react.createElement("span", {}, ...children_6))], react.createElement("div", {
        className: "username has-text-centered",
    }, ...children_8)), (children_10 = [(props_10 = [new HTMLAttr(149, [iconUrl(image, icontype)])], react.createElement("img", keyValueList(props_10, 1)))], react.createElement("div", {
        className: "image-wrapper",
    }, ...children_10)), react.createElement("div", {
        className: "username has-text-centered",
    }, html)], react.createElement("div", {
        className: "card-body",
    }, ...children_14))], react.createElement("div", {
        onClick: (e) => {
            if (onClick != null) {
                value(onClick)(e);
            }
        },
        className: "flat-card help-card upload-card is-auto",
    }, ...children_16))];
    return react.createElement("div", {
        className: "column is-4",
    }, ...children_18);
}

function wideHtmlBox(columnClass, ueberschrift, image, icontype, html, additionalLink, onClick) {
    let children_24, children_22, children, props, children_20;
    const children_26 = [(children_24 = [(children_22 = [(children = [(props = [new HTMLAttr(149, [iconUrl(image, icontype)])], react.createElement("img", keyValueList(props, 1)))], react.createElement("div", {
        className: "image-wrapper",
    }, ...children)), (children_20 = toList(delay(() => {
        let children_10, children_8, children_6;
        return append(singleton((children_10 = [(children_8 = [(children_6 = toList(delay(() => singleton((onClick == null) ? react.createElement("span", {
            className: "help-head",
        }, ueberschrift) : react.createElement("a", {
            className: "help-head",
        }, ueberschrift)))), react.createElement("b", {}, ...children_6))], react.createElement("span", {}, ...children_8))], react.createElement("div", {
            className: "username",
        }, ...children_10))), delay(() => append(singleton(react.createElement("div", {
            className: "username",
        }, html)), delay(() => {
            let children_18, children_16;
            return (additionalLink != null) ? singleton((children_18 = [(children_16 = [value(additionalLink), react.createElement("i", {
                className: "fas fa-angle-right fa-lg",
            })], react.createElement("a", {}, ...children_16))], react.createElement("div", {
                className: "view-more",
            }, ...children_18))) : empty();
        }))));
    })), react.createElement("div", {
        className: "help-card-content-wide",
    }, ...children_20))], react.createElement("div", {
        className: "card-body card-body-wide ",
    }, ...children_22))], react.createElement("div", {
        onClick: (e) => {
            if (onClick != null) {
                value(onClick)(e);
            }
        },
        className: "flat-card help-card upload-card is-auto",
    }, ...children_24))];
    return react.createElement("div", {
        className: columnClass,
    }, ...children_26);
}

export function htmlBox(size) {
    switch (size.tag) {
        case 1:
            return (ueberschrift_1) => ((image_1) => ((icontype_1) => ((html_1) => ((additionalLink_1) => ((onClick_1) => wideHtmlBox("column is-6", ueberschrift_1, image_1, icontype_1, html_1, additionalLink_1, onClick_1))))));
        case 2:
            return (ueberschrift_2) => ((image_2) => ((icontype_2) => ((html_2) => ((additionalLink_2) => ((onClick_2) => wideHtmlBox("column is-12", ueberschrift_2, image_2, icontype_2, html_2, additionalLink_2, onClick_2))))));
        default:
            return (ueberschrift) => ((image) => ((icontype) => ((html) => ((additionalLink) => ((onClick) => narrowhtmlBox(ueberschrift, image, icontype, html, additionalLink, onClick))))));
    }
}

export function textBox(size, ueberschrift, image, icontype, text, onClick) {
    return htmlBox(size)(ueberschrift)(image)(icontype)(react.createElement("span", {}, text))(onClick);
}

export function ticketBox(size, navigateTo) {
    return htmlBox(size)("BFS Ticket-System")("bfs_ticketsystem")(new IconType(2, []))(react.createElement("div", {}, "Erstellen Sie, für Ihr individuelles Anliegen, ein Ticket an unseren Kundenservice."))("zum Ticket-System")((_arg) => {
        navigateTo(new Page(0, []));
    });
}

export const fullWidthTicketBox = (navigateTo) => ticketBox(new HelpBoxSize(2, []), navigateTo);

function ticketTile(navigateTo) {
    let children_4, s_1;
    const children_8 = [bfsTile("BFS Ticket-System", react.createElement("a", {
        onClick: (_arg) => {
            navigateTo(new Page(0, []));
        },
    }, navigationArrow), react.createElement("img", {
        className: "dashboard-icon",
        src: "kontakt/kontakt_ticket_96x96.svg",
    }), [react.createElement("div", {
        className: "large",
    }, "Bequem und einfach!"), (children_4 = [(s_1 = "Senden Sie uns unkompliziert Ihren Sachverhalt zu. Den aktuellen Bearbeitungsstand Ihrer Anfrage können Sie jederzeit einsehen. So behalten Sie immer den Überblick.", s_1)], react.createElement("div", {
        className: "subtle mt-1",
    }, ...children_4)), react.createElement("a", {
        className: "bfsbutton is-rounded mt-4 mb-4 action is-size-7",
        onClick: (_arg_1) => {
            navigateTo(new Page(0, []));
        },
    }, "Jetzt Ticket erstellen!")], undefined)];
    return react.createElement("div", {
        className: "ticket-card",
    }, ...children_8);
}

function chatTile(model) {
    let children_4, s_1;
    const children_8 = [bfsTile("Chat", undefined, Array.from(delay(() => {
        let props;
        const matchValue = model.Ansprechpartner;
        let matchResult, body_1;
        if (matchValue.tag === 3) {
            if (matchValue.fields[0].ImageUrl != null) {
                matchResult = 0;
                body_1 = matchValue.fields[0];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return append(singleton((props = [new HTMLAttr(65, ["dashboard-icon is-rounded"]), new HTMLAttr(149, [defaultArg(body_1.ImageUrl, "kontakt/kontakt_chat_100x100.svg")])], react.createElement("img", keyValueList(props, 1)))), delay(() => {
                    let children;
                    return singleton((children = [react.createElement("img", {
                        src: "kontakt/kontakt_chat_48x48.svg",
                    })], react.createElement("div", {
                        className: "dashboard-icon-addon",
                    }, ...children)));
                }));
            default:
                return singleton(react.createElement("img", {
                    className: "dashboard-icon",
                    src: "kontakt/kontakt_chat_100x100.svg",
                }));
        }
    })), [react.createElement("div", {
        className: "large",
    }, "Wir freuen uns auf Ihre Fragen!"), (children_4 = [(s_1 = "Über den Chat erreichen Sie unsere Mitarbeitenden, die Ihnen gerne behilflich sind. Auch außerhalb unserer Geschäftszeiten können Sie uns eine Nachricht senden.", s_1)], react.createElement("div", {
        className: "subtle mt-1",
    }, ...children_4)), react.createElement("a", {
        className: "bfsbutton is-rounded mt-4 mb-4 action  is-size-7",
        onClick: (_arg) => {
            openChat();
        },
    }, "Jetzt Chat starten!")], undefined)];
    return react.createElement("div", {
        className: "chat-card",
    }, ...children_8);
}

const emailTile = (() => {
    let children, s, children_4;
    const children_6 = [bfsTile("E-Mail", undefined, react.createElement("img", {
        className: "dashboard-icon",
        src: "kontakt/kontakt_email_96x96.svg",
    }), [(children = [(s = "Sie möchten uns Ihr Anliegen per E-Mail zukommen lassen oder haben Dokumente, die Sie als Anhang versenden wollen? Wir bearbeiten Ihr Anliegen unter:", s)], react.createElement("div", {
        className: "subtle mt-1",
    }, ...children)), (children_4 = [react.createElement("a", {
        href: "mailto:service@bfs-abrechnung.de",
    }, "service@bfs-abrechnung.de")], react.createElement("div", {
        className: "mt-4 action",
    }, ...children_4))], undefined)];
    return react.createElement("div", {
        className: "email-card",
    }, ...children_6);
})();

function telefonTile(model) {
    let matchValue, matchValue_2, body_1, children_6;
    const children_8 = [bfsTile("Telefon", undefined, (matchValue = model.Ansprechpartner, (matchValue.tag === 3) ? Array.from(delay(() => {
        const matchValue_1 = matchValue.fields[0].ImageUrl;
        if (matchValue_1 == null) {
            return singleton(react.createElement("img", {
                className: "dashboard-icon",
                src: "kontakt/kontakt_telefon_100x100.svg",
            }));
        }
        else {
            const url = matchValue_1;
            return append(singleton(react.createElement("img", {
                className: "dashboard-icon is-rounded",
                src: url,
            })), delay(() => {
                let children;
                return singleton((children = [react.createElement("img", {
                    src: "kontakt/Kontakt_telefon_48x48.svg",
                })], react.createElement("div", {
                    className: "dashboard-icon-addon",
                }, ...children)));
            }));
        }
    })) : react.createElement("img", {
        className: "dashboard-icon",
        src: "kontakt/kontakt_telefon_100x100.svg",
    })), (matchValue_2 = model.Ansprechpartner, (matchValue_2.tag === 1) ? spinner : ((matchValue_2.tag === 2) ? errorMsg("Fehler beim Laden des Ansprechpartners") : ((matchValue_2.tag === 3) ? ((body_1 = matchValue_2.fields[0], [react.createElement("div", {
        className: "subtle mt-1",
    }, body_1.Text), (children_6 = [react.createElement("a", {
        href: `tel:${body_1.Telefon}`,
    }, body_1.Telefon)], react.createElement("div", {
        className: "mt-4 action",
    }, ...children_6))])) : nothing))), undefined)];
    return react.createElement("div", {
        className: "telefon-card",
    }, ...children_8);
}

export function view(model, dispatch, navigateTo) {
    const children = [ticketTile((arg) => {
        navigateTo(arg);
    }), chatTile(model), emailTile, telefonTile(model)];
    return react.createElement("div", {
        className: "kontakt-grid",
    }, ...children);
}

//# sourceMappingURL=View.fs.js.map
